/**
 * Bless Brothers – Recently Viewed slider (final)
 */
(function () {
  const IDS = {
    WRAPPER: 'recently-viewed-wrapper',
    BOX:     'recently-viewed-products',
    CFG:     'recently-viewed-config'
  };

  const DEBUG = false;
  const log = (...a)=>DEBUG&&console.log('[RV]',...a);

  async function render() {
    log('render start');

    const wrapper   = document.getElementById(IDS.WRAPPER);
    const slidesBox = document.getElementById(IDS.BOX);
    if (!wrapper || !slidesBox) return;

    // ---------- read config from inline JSON -----------
    let cfg = {};
    try {
      cfg = JSON.parse(document.getElementById(IDS.CFG)?.textContent || '{}');
    } catch (e) { log('cfg parse error', e); }

    const maxItems   = Number(cfg.products_to_show) || 8;
    const imgRatio   = cfg.image_ratio || 'square';
    const align      = cfg.text_alignment || 'left';
    const showVendor = !!cfg.show_vendor;
    const showRating = !!cfg.show_rating;
    const showHover  = !!cfg.show_secondary_image_on_hover;

    // ---------- grab handles -----------
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('recently_viewed') || '[]'); }
    catch(e){}

    if (!handles.length) { log('no handles'); return; }

    handles = handles.slice(-maxItems).reverse(); // newest first / limited
    log('handles', handles);

    // ---------- fetch cards -----------
    const cardHtmls = await Promise.all(
      handles.map(async (h) => {
        const params = new URLSearchParams({
          view:        'card',
          vendor:      showVendor,
          rating:      showRating,
          options:     false,
          alignment:   align,
          media_ratio: imgRatio,
          hover:       showHover
        });
        const url = `/products/${encodeURIComponent(h)}?${params.toString()}`;
        log('fetch', url);
        try {
          const res = await fetch(url, { credentials: 'same-origin' });
          if (!res.ok) throw new Error(res.statusText);
          const html = await res.text();
          return `<div data-swiper-slide>${html}</div>`;
        } catch(err){
          console.warn('[RV] fetch failed', h, err);
          return '';
        }
      })
    );

    const html = cardHtmls.filter(Boolean).join('');
    if (!html) return;

    slidesBox.innerHTML = html;

    // reveal section
    wrapper.style.removeProperty('display');

    // ---------- init/update swiper -----------
    await customElements.whenDefined('slideshow-section');
    const host     = wrapper.querySelector('slideshow-section');
    const cfgEl    = wrapper.querySelector('[data-swiper-configuration]');
    const slideCnt = slidesBox.querySelectorAll('[data-swiper-slide]').length;

    if (!host || !cfgEl) { log('no host or cfgEl'); return; }

    // adjust config to avoid "not enough slides" lock
    let swCfg = {};
    try { swCfg = JSON.parse(cfgEl.textContent || '{}'); } catch(e){}
    ['320','900'].forEach(bp=>{
      if(swCfg.breakpoints?.[bp]){
        const wanted = swCfg.breakpoints[bp].slidesPerView;
        const fixed  = Math.min(slideCnt, wanted);
        swCfg.breakpoints[bp].slidesPerView  = fixed;
        swCfg.breakpoints[bp].slidesPerGroup = fixed;
      }
    });
    cfgEl.textContent = JSON.stringify(swCfg);

    // hard enable nav/scrollbar later
    const enableNav = () => {
      wrapper.querySelectorAll('.swiper-button-lock').forEach(btn=>{
        btn.classList.remove('swiper-button-lock');
        btn.removeAttribute('aria-disabled');
        btn.tabIndex = 0;
      });
      const sb = wrapper.querySelector('.swiper-scrollbar');
      if(sb){ sb.style.display = ''; }
    };

    try {
      if (host.swiper) {
        // Wonder exposes destroy/init helpers
        host.swiperDestroy();
        host.readConfiguration();
        host.swiperInitilize();
      } else {
        host.readConfiguration();
        host.swiperInitilize();
      }
      // after Swiper is ready, force nav enabled
      setTimeout(()=>{
        enableNav();
        host.swiper?.update();
        host.swiper?.navigation?.update();
        host.swiper?.scrollbar?.updateSize?.();
        log('swiper updated');
      }, 50);
    } catch(e){
      console.warn('[RV] swiper init/update error', e);
    }
  }

  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', render);
    } else {
      render();
    }

    // Theme editor re-render
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) => {
        const id = document.getElementById(IDS.WRAPPER)?.dataset.sectionId;
        if (e.detail.sectionId === id) render();
      });
    }
  }

  boot();
})();
